import template from './utilities-terms-switcher.jade';
import { locationPathChanged } from '../../../../../blocks/segments/address/address.events';
import { ERegions } from '../../../../../../../shared/constants';

const items = [
  {
    text: 'Включены',
    value: true,
  },
  {
    text: 'Не включены',
    value: false,
  },
];

// всегда включены для Москвы, МО
// Для СПБ и ЛО зависит от фича тогла addForm.UtilitiesTerms.Enabled
export const getIncludedLocationIds = isExcludeUtilitiesTermsEnabled => {
  let locationIds = [ERegions.moscow, ERegions.moscowRegion];

  if (!isExcludeUtilitiesTermsEnabled) {
    const spbLocations = [ERegions.spb, ERegions.spbRegion];
    locationIds = [...locationIds, ...spbLocations];
  }

  return locationIds;
};

export default angular
  .module('cian.addForm.bargainTermsUtilitiesTerms')
  .directive('cianAfPriceAndDealTermsUtilitiesTermsSwitcher', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller($scope, geoService, deviceService, excludeUtilitiesTermsRegionsService) {
      'ngInject';

      const { isFeatureToggleEnabled } = excludeUtilitiesTermsRegionsService;

      this.isMobile = deviceService.isMobile;
      this.ad.bargainTerms.utilitiesTerms.includedInPrice =
        this.ad.bargainTerms.utilitiesTerms.includedInPrice || false;

      this.items = items;

      const disableSwitcher = disable => {
        // eslint-disable-next-line no-param-reassign
        items.forEach(item => {
          item.disabled = disable && !item.value;
        });
      };

      const checkIncludedPriceValue = () => {
        const locationId = geoService.getLocationId();
        const includedLocationIds = getIncludedLocationIds(isFeatureToggleEnabled);
        const forceInclude = includedLocationIds.includes(locationId);

        disableSwitcher(forceInclude);

        if (forceInclude) {
          this.ad.bargainTerms.utilitiesTerms.includedInPrice = true;
          this.ad.bargainTerms.utilitiesTerms.price = undefined;
        }
      };

      $scope.$on(locationPathChanged, checkIncludedPriceValue);

      $scope.$watch(
        () => this.ad.bargainTerms.utilitiesTerms.includedInPrice,
        included => {
          if (included) {
            const includedLocationIds = getIncludedLocationIds(isFeatureToggleEnabled);

            disableSwitcher(includedLocationIds.includes(geoService.getLocationId()));
            delete this.ad.bargainTerms.utilitiesTerms.price;
          }
        },
      );

      checkIncludedPriceValue();
    },
    controllerAs: 'utilitiesTermsSwitcherCtrl',
    template,
  })).name;
